import { createFileRoute } from "@tanstack/react-router";
import { CorrectionsPolicyPage } from "@/pages/trust/TrustPages";
import { breadcrumbJsonLd } from "@/config/seoConfig";
import { seoHead } from "@/lib/seo/head";

export const Route = createFileRoute("/corrections-policy")({
  head: () =>
    seoHead({
      title: "Corrections Policy",
      description: "How to report a factual error on LeadXkids and how corrections and update notes are handled.",
      canonical: "/corrections-policy",
      pageType: "WebPage",
      jsonLd: [
        breadcrumbJsonLd([
          { name: "Home", url: "/" },
          { name: "Corrections policy", url: "/corrections-policy" },
        ]),
      ],
    }),
  component: CorrectionsPolicyPage,
});
